// extracted by mini-css-extract-plugin
export default {"container":"labelText_container__KxknQ","label":"labelText_label__oRi+3","text":"labelText_text__v8E4U"};